export default function PrivacyPage() {
  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-6">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground mb-8">Last Updated: January 2026</p>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">1. Information We Collect</h2>
            <p className="leading-relaxed">
              We collect information you provide directly to us, such as when you create an account, subscribe to our newsletter, submit a contact form, or interact with our services. This may include your name, email address, and any other information you choose to provide.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="leading-relaxed">
              We use the information we collect to:
            </p>
            <ul className="list-disc ml-6 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Send you newsletters, updates, and marketing communications</li>
              <li>Respond to your comments and questions</li>
              <li>Analyze usage patterns and trends</li>
              <li>Protect against fraudulent or illegal activity</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">3. Information Sharing</h2>
            <p className="leading-relaxed">
              We do not sell your personal information. We may share your information with third-party service providers who perform services on our behalf, such as email delivery, analytics, and customer support.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">4. Cookies and Tracking</h2>
            <p className="leading-relaxed">
              We use cookies and similar tracking technologies to collect information about your browsing activities. You can control cookies through your browser settings.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">5. Data Security</h2>
            <p className="leading-relaxed">
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">6. Your Rights</h2>
            <p className="leading-relaxed">
              You have the right to access, update, or delete your personal information. You can unsubscribe from marketing communications at any time by clicking the unsubscribe link in our emails.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-foreground mt-8 mb-4">7. Contact Us</h2>
            <p className="leading-relaxed">
              If you have questions about this Privacy Policy, please contact us at:<br />
              <strong>Email:</strong> <a href="mailto:contact@insidehighereducation.eu" className="text-accent hover:underline">contact@insidehighereducation.eu</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}